var _this = this;

import React, { useEffect, useState } from "react";
import { Toast } from "dyson/src/components/atoms/toast/Toast";
import mitt from "mitt";
import { jsx as ___EmotionJSX } from "@emotion/core";
export var snackBarEmitter = mitt();
export var Snackbar = function Snackbar() {
  var _useState = useState(null),
      event = _useState[0],
      setEvent = _useState[1];

  useEffect(function () {
    snackBarEmitter.on("snackbar-notify", function (e) {
      setEvent(e);
      setTimeout(function () {
        setEvent(null);
      }, 7000);
    });
  }, []);
  if (event === null) return null;
  return ___EmotionJSX(Toast, {
    type: event.type,
    onClose: setEvent.bind(_this, null)
  }, event.message);
};